export default "__VITE_ASSET__ConqstLf__"